export default __webpack_public_path__ + "static/media/checkMail.49cb2265.svg";